import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    content: String,
    copiedText: { type: String, default: "Copied!" },
    toastText: { type: String, default: "Copied issue URL to clipboard!" }
  }

  static targets = ["icon", "label"]

  copy(event) {
    event.preventDefault()
    event.stopPropagation()

    const url = this.contentValue

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(() => {
        this.showCopied()
      }).catch(err => {
        this.fallbackCopy(url)
      })
    } else {
      this.fallbackCopy(url)
    }
  }

  fallbackCopy(text) {
    try {
      const textarea = document.createElement("textarea")
      textarea.value = text
      
      // Ensure it is completely invisible and doesn't trigger scrollbars
      textarea.style.position = "fixed"
      textarea.style.top = "-9999px"
      textarea.style.left = "-9999px"
      textarea.style.width = "2em"
      textarea.style.height = "2em"
      textarea.style.padding = "0"
      textarea.style.border = "none"
      textarea.style.outline = "none"
      textarea.style.boxShadow = "none"
      textarea.style.background = "transparent"

      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()

      const successful = document.execCommand("copy")
      document.body.removeChild(textarea)

      if (successful) {
        this.showCopied()
      } else {
        console.error("Fallback copy was unsuccessful")
      }
    } catch (err) {
      console.error("Fallback copy error: ", err)
    }
  }

  showCopied() {
    this.showToast(this.toastTextValue)

    // Visual feedback on the button if targets are present
    if (this.hasIconTarget && this.hasLabelTarget) {
      const originalIcon = this.iconTarget.innerHTML
      const originalLabel = this.labelTarget.textContent

      // Swap color classes for green feedback
      const grayTextClasses = ["text-gray-700", "dark:text-gray-300"]
      const grayBorderClasses = ["border-gray-300", "dark:border-gray-700"]
      const greenTextClasses = ["text-green-600", "dark:text-green-400"]
      const greenBorderClasses = ["border-green-500", "dark:border-green-500"]

      this.element.classList.remove(...grayTextClasses, ...grayBorderClasses)
      this.element.classList.add(...greenTextClasses, ...greenBorderClasses)
      this.labelTarget.textContent = this.copiedTextValue
      this.iconTarget.innerHTML = '<path d="M4 10.5l4 4 8-9"/>'

      setTimeout(() => {
        this.element.classList.remove(...greenTextClasses, ...greenBorderClasses)
        this.element.classList.add(...grayTextClasses, ...grayBorderClasses)
        this.labelTarget.textContent = originalLabel
        this.iconTarget.innerHTML = originalIcon
      }, 1600)
    }
  }

  showToast(message) {
    const flashContainer = document.getElementById("flash")
    if (!flashContainer) return

    const toast = document.createElement("div")
    toast.setAttribute("data-controller", "flash")
    toast.className = "pointer-events-auto px-4 py-3 rounded-lg shadow-lg text-sm font-medium bg-gray-900 text-white dark:bg-gray-100 dark:text-gray-900 transition-all duration-300 transform translate-y-0"
    toast.textContent = message

    flashContainer.appendChild(toast)
  }
}

